import React, { useEffect, useState } from "react";
import { getBlogs, deleteBlog } from "../../api/BlogService";
import { getErrorMessage } from "../../utils/errorHandler";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
export default function Blog() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getBlogs(currentPage, itemsPerPage);
      const data = Array.isArray(res?.data) ? res.data : [];
      const pagination = res?.pagination || {};
      setList(data);
      setTotalItems(
        pagination?.totalItems || pagination?.totalitems || pagination?.total || data.length || 0,
      );
      setErrorMessage("");
    } catch (err) {
      console.error("Failed to fetch blogs:", err);
      setErrorMessage(getErrorMessage(err));
      setList([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, [currentPage]);
  if (loading) {
    return (
      <div className="d-flex vh-100 align-items-center justify-content-center">
        <p className="m-0">Loading Blogs...</p>
      </div>
    );
  }

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this blog?");

    if (!confirmDelete) return;

    try {
      const res = await deleteBlog(id);

      if (res.success) {
        // remove deleted item from UI
        setList((prev) => prev.filter((item) => item._id !== id));
      }
    } catch (error) {
      console.error("Delete Error:", error);

      setErrorMessage(error?.response?.data?.message || "Failed to delete blog");
    }
  };

  return (
    <div className="container-fluid p-4 np-blog-page">
      {/* ERROR */}
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      {/* HEADER */}
      <div className="d-flex justify-content-end align-items-center mb-3">
        <button
          className="btn btn-primary d-flex align-items-center gap-2"
          onClick={() => navigate("/blog/add")}
        >
          <FaPlus />
          Add Blog
        </button>
      </div>
      {/* TABLE */}
      <div className="card p-3">
        <div className="table-responsive">
          <table
            className="table table-bordered table-hover"
            style={{
              borderColor: "#dee2e6",
            }}
          >
            <thead className="bg-light">
              <tr>
                <th className="text-dark fw-bold">#</th>
                <th className="text-dark fw-bold">Title</th>
                <th className="text-dark fw-bold">Category</th>
                <th className="text-dark fw-bold">Read Time</th>
                <th className="text-dark fw-bold">Status</th>
                <th className="text-dark fw-bold text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Blogs Found
                  </td>
                </tr>
              ) : (
                list.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>
                      <div className="fw-semibold">{item.title || "-"}</div>
                      <small className="text-muted">{item.blogDescription || "-"}</small>
                    </td>
                    <td>{item.category?.name || "-"}</td>
                    <td>{item.readingTime ? `${item.readingTime} min` : "-"}</td>
                    <td>
                      <span
                        className={`badge ${
                          item.status === "ACTIVE" ? "bg-success" : "bg-secondary"
                        }`}
                      >
                        {item.status || "-"}
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center align-items-center gap-3 np-table-actions">
                        <FaEye
                          className="np-table-action-icon"
                          style={{
                            cursor: "pointer",
                            marginRight: "5px",
                          }}
                          onClick={() => navigate(`/blog/view/${item.seo?.slug}`)}
                        />

                        <FaEdit
                          className="np-table-action-icon"
                          style={{
                            cursor: "pointer",
                            marginRight: "5px",
                          }}
                          onClick={() =>
                            navigate(`/blog/edit/${item.seo?.slug}`, {
                              state: {
                                blogId: item._id,
                                blogslug: item.seo?.slug,
                              },
                            })
                          }
                        />

                        <FaTrash
                          className="np-table-action-icon"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => handleDelete(item._id)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* PAGINATION */}
      <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
}
